import * as React from 'react'

import { SimpleTitleButtonHero } from 'sdk/sections'

import type { AboutHeroCmsContent } from 'core/services/cms/interfaces'

import aboutHeroVideo from '../../assets/about-hero-video.webm'

interface HeroProps {
  content: AboutHeroCmsContent
}

export const Hero: React.FC<HeroProps> = ({ content }) => {
  return (
    <SimpleTitleButtonHero
      title={content.titleText}
      description={content.description}
      imageLink="" // Will be overridden by video
      videoLink={aboutHeroVideo}
      alignment="center"
    />
  )
}
